// src/data/projectSkillMapping.js
export const projectCharacteristics = [
  {
    id: 'innovation',
    name: '高い新規性・創造性',
    emoji: '💡',
    description: '前例のない革新的なアイデアが求められるプロジェクト。',
    relatedAbilities: { 'I': 0.4, 'O': 0.3, 'I2': 0.2, 'H': 0.1 },
    relatedCognition: { thinkingStyle: 'divergent' },
    baseDuration: 12,
    milestones: ['アイデア発散・収束', 'プロトタイプ検証', 'ピボット判断', '本格開発', 'リリース'],
  },
  {
    id: 'speed',
    name: '迅速な実行力・スピード',
    emoji: '⚡',
    description: '市場投入までの時間が重要なアジャイルプロジェクト。',
    relatedAbilities: { 'I2': 0.4, 'O2': 0.3, 'N': 0.2, 'H': 0.1 },
    relatedCognition: { attentionPattern: 'variable' },
    baseDuration: 6,
    milestones: ['要件定義', 'スプリント1', 'スプリント2', 'MVP完成', 'リリース'],
  },
  {
    id: 'quality',
    name: '緻密な品質管理',
    emoji: '🔬',
    description: 'ミスが許されない高い正確性が求められるプロジェクト。',
    relatedAbilities: { 'N': 0.4, 'O2': 0.3, 'O': 0.2, 'R': 0.1 },
    relatedCognition: { processingStyle: 'sequential' },
    baseDuration: 18,
    milestones: ['要件定義', '設計・仕様策定', '実装', 'QAテスト', '受入検査', 'リリース'],
  },
  {
    id: 'coordination',
    name: '複雑なステークホルダー調整',
    emoji: '🤝',
    description: '多くの部署・社外関係者との調整が鍵のプロジェクト。',
    relatedAbilities: { 'H': 0.4, 'S': 0.3, 'B': 0.3 },
    relatedCognition: { processingStyle: 'holistic' },
    baseDuration: 9,
    milestones: ['関係者特定', '個別折衝', '合意形成', '計画承認', '実行・報告'],
  },
  {
    id: 'data_driven',
    name: 'データ分析・意思決定',
    emoji: '📊',
    description: '大量データの分析と、それに基づく意思決定が求められるプロジェクト。',
    relatedAbilities: { 'O': 0.4, 'N': 0.3, 'O2': 0.2, 'R': 0.1 },
    relatedCognition: { processingStyle: 'sequential' },
    baseDuration: 10,
    milestones: ['データ収集・整備', '探索的分析', 'モデル構築', '検証', '意思決定・実装'],
  },
  {
    id: 'change_management',
    name: '組織変革・チェンジマネジメント',
    emoji: '🔄',
    description: '人や組織の行動変容を伴う、変革推進プロジェクト。',
    relatedAbilities: { 'S': 0.4, 'H': 0.3, 'B': 0.2, 'I2': 0.1 },
    relatedCognition: { processingStyle: 'holistic' },
    baseDuration: 24,
    milestones: ['現状分析', 'ビジョン策定', 'パイロット実施', '展開計画', '全体展開', '定着化'],
  },
  {
    id: 'cost_reduction',
    name: 'コスト削減・業務効率化',
    emoji: '💰',
    description: '既存プロセスの改善・自動化によるコスト削減プロジェクト。',
    relatedAbilities: { 'O2': 0.4, 'N': 0.3, 'R': 0.2, 'O': 0.1 },
    relatedCognition: { processingStyle: 'sequential' },
    baseDuration: 8,
    milestones: ['現状把握・計測', '改善案策定', 'PoC実施', '本格展開', '効果測定'],
  },
  {
    id: 'customer_experience',
    name: '顧客体験・UX改善',
    emoji: '✨',
    description: '顧客視点での体験設計・改善が中心のプロジェクト。',
    relatedAbilities: { 'H': 0.3, 'I': 0.3, 'S': 0.2, 'O': 0.2 },
    relatedCognition: { thinkingStyle: 'divergent' },
    baseDuration: 10,
    milestones: ['ユーザーリサーチ', '課題定義', 'プロトタイプ', 'ユーザーテスト', 'リリース・計測'],
  },
];
